export default __webpack_public_path__ + "static/media/fitternity-card.dd5f35a9.svg";